import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, Subject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  AuthService, CookieService, EventsService, UtilService, VariablesService, PaymentService, VwoService
} from '../../../../shared/services';
import { ICart } from '../../models/cart.model';
import { IContribute } from '../../models/contribute.model';
import { IOrder } from '../../models/order.model';
import { IPaymentConfig } from '../../models/payment.model';

declare let fbp_purchase_data;
@Injectable()
export class PaymentUtilService {

  /**Send payment screen state*/
  public isSubmitted = new BehaviorSubject<any>(false);
  /**subscription service for cartresponse */
  public cartSubs: Subscription[] = [];
  /**After creation of the cart */
  public cartResponse = new BehaviorSubject<ICart>(null);
  /** Payment options response observable */
  public paymentOptionsObs = new BehaviorSubject<any>(null);
  /**Supported currencies for the the payment */
  public supportedCurrencies = new BehaviorSubject<any>(null);
  /**Currency selected by the donor for donation */
  public paymentCurrency = new BehaviorSubject<any>(null);
  /**Rewards selected byt the donor */
  public selectedReward = new BehaviorSubject<any>(null);
  /**Back click on payment modal */
  public backButton = new BehaviorSubject<any>('');

  public utmProceedClicked = false;
  public upiOptions: any = [
    { label: 'Paytm', name: '', class: 'PAYTM' },
    { label: 'Google Pay', name: 'tez', class: 'gpay' },
    { label: 'Whatsapp Pay', name: 'whatsapp_pay', class: 'whatsapp' },
    { label: 'Phone Pe', name: 'Phone_pe', class: 'PHONEPE' },
    { label: 'BHIM', name: 'bhim', class: 'bhim' },
  ];
  public miniApps = new Subject();
  public isPhonePe = new Subject();
  /**Initaite teh qr code order */
  public initaiteQr;
  /** Switch the pyment from defalut to recurring */
  public switchPaymen = new Subject<boolean>();
  public paymentMode = 'default';
  public contributeDetails: IContribute;

  paymentConfig = new BehaviorSubject<IPaymentConfig>(null);

  constructor(
    private eventsService: EventsService,
    private vars: VariablesService,
    private cookieService: CookieService,
    private util: UtilService,
    public authService: AuthService,
    private paymentService: PaymentService,
    private vwo: VwoService
  ) { }

  getMinimumAmountSIP(currency: string) {
    const currencies = this.vars.min_sip_amounts;
    currencies.INR = this.vars.typSipAmountDefaultINR;
    if (currency) {
      return this.util.formatAmount(currencies[currency.toUpperCase()], currency);
    }
  }
  getMinimumAmountOnlySIP(currency: string) {
    const currencies = this.vars.min_sip_amounts;
    currencies.INR = this.vars.typSipAmountDefaultINR;
    return currencies[currency];
  }

  createCart(amount, pledgeMore?, storeCart?) {
    return new Promise((resolve, reject) => {
      try {
        const user = this.vars.userData.getValue();
        const client = this.vars.clientLocationData.getValue();
        const payload = {
          'campaign_id': this.contributeDetails?.campaign?.id || this.vars.fundraiser?.id,
          'currency': this.paymentCurrency.getValue(),
          'donated_amount': amount,
          'donor_name': user.full_name,
          'donor_phone': user.phone_1 ? user.phone_1 : '1111111111',
          'donor_email': user.email,
          'is_anonymous': this.contributeDetails?.is_anonymous ? '1' : '0',
          'device': this.vars.deviceType,
          'donor_country': client && client.country_name,
          'donor_city': client?.city_name,
          'donor_extension': user.extension || '',
          'donor_pincode': user.pincode || '',
          'recurring': 1
        };
        if (this.vars.selected_insurance) {
          payload['vendor'] = this.vars.selected_insurance.vendor;
          payload['plan'] = this.vars.selected_insurance.plan;
          payload['plan_id'] = this.vars.insurance_vendors.medibuddy.yearly[payload['plan']]?.plan_id;
          if (this.vars.selectedIllness?.illnessAmount) {
            payload['critical_illness'] = this.vars.selectedIllness.illnessAmount;
          }
        }
        if (this.vars.couponDetails) {
          payload['coupon_code'] = this.vars.couponDetails.coupon_code;
        }

        if (this.vars.selected_insurance?.frequency === 'yearly') { delete payload['recurring']; }
        if (pledgeMore) { payload['pledge_more'] = 1; }

        if (this.vars.selectedKCart) {
          payload['campaign_products'] = this.vars.selectedKCart;
          this.util.storage.check('selectedKCart', this.vars.selectedKCart);
        } else {
          this.util.storage.delete('selectedKCart');
        }

        this.vars.isOrderLoading = true;
        this.paymentService.sendAmount(payload, payload.campaign_id).subscribe((res: any) => {
          if (this.vars.isDummyEmail) {
            this.eventsService.updateCTprofile({name: payload?.donor_name, email: payload?.donor_email});
          }
          let extraCartData = {
            timestamp: new Date().getTime()
          };
          if (this.vars.selected_insurance) {
            extraCartData['vendor'] = this.vars.selected_insurance.vendor;
            extraCartData['plan'] = this.vars.selected_insurance.plan;
          }
          if (this.vars.showKCart) {
            extraCartData['showKCart'] = true;
          }
          if (this.vars.showKCart && this.vars.selectedKCart) {
            extraCartData['campaign_products'] = this.vars.selectedKCart;
          }
          const cartData = { ...res.data.cart, ...extraCartData };
          if (storeCart) {
            this.util.storage.checkFromSession('cartData', cartData);
          }
          this.vars.isOrderLoading = false;
          this.cartResponse.next(cartData);
          this.vars.getCartInsurance.next(cartData);
          this.vars.fundraiser = res.data.campaign;
          this.contributeDetails = { ...this.contributeDetails, campaign: res.data.campaign };
          if (res.data.hasOwnProperty('token')) {
            this.vars.loginMethod = 'cart';
            this.authService.userLogin(res.data);
          }
          const data = {
            isLoggedIn: true,
            extn: payload.donor_extension,
            campaignId: this.contributeDetails.campaign.id,
            reward: '',
            currency: payload.currency,
            amount: amount
          };
          this.donationFormEvents(cartData, data, true);
          resolve(true);
        },
          (err) => {
            this.vars.isOrderLoading = false;
          });
      } catch (error) {
        reject(error);
      }
    });
  }


  /**All the events for the payment donation form */
  donationFormEvents(cartResponse: ICart, data, onpage?) {
    /**Initiate the payment if the story page in desktop mode */
    if (onpage) {
      this.contributeInitiatedEvents(data?.position);
    }
    // if non logged in then push claver tap profile
    if (!data?.isLoggedIn) {
      const claverTapData = {
        'Site': {
          'Identity': cartResponse.donor_entity_details_id,
          'Email': cartResponse.donor_email,
          'Name': cartResponse.donor_name,
          'Phone': (data?.extn || '') + cartResponse.donor_phone,
          'Mobile': (data?.extn || '') + cartResponse.donor_phone,
          'Full Name': cartResponse.donor_name,
          'Full Name For URL': encodeURI(cartResponse.donor_name),
          country_code: data?.extn || ''
        }
      };
      this.eventsService.claverProfilePush(claverTapData);
    }
    let info1 = this.vars.event_info.info_1;
    if (data && data.slabs) {
      info1 = `${JSON.stringify(data.slabs)}/${cartResponse.donated_amount}`;
    }

    if (this.vars.selectedKCart) {
      info1 = this.getSelectedProductAsInfo();
    }

    /**System event push */
    const systemEventCartCreate = {
      eventName: 'Contribution Cart',
      event_type: 'campaign',
      page_name: this.vars.pageName || '',
      info_1: info1,
      info_2: cartResponse.id,
      info_3: this.vars.event_info.info_3 || this.vars.campaignType + (data?.info3 ? ',' + data?.info3 : ''),
      info_4: this.vars?.event_info?.info_4 || this.cookieService.getCookie('varAB') || data?.info4 || ''
    };

    if (this.vars.fundraiser?.is_multi_patient_campaign && this.vars.pageName.match('stories|mini_story')) {
      systemEventCartCreate.info_3 += this.vars.donateMultiPatient ? ',multi_p_enabled' : ',multi_p_disabled';
    }

    if (data?.campaignId) {
      systemEventCartCreate['event_type_id'] = data?.campaignId;
    }

    this.eventsService.sendSystemEvent(systemEventCartCreate).subscribe(_ => _);
    // Criteo Basket/Cart dataLayer of GTM push
    const dataLayerCartCreate = {
      event: 'crto_basketpage',
      currency: cartResponse.currency,
      crto: {
        email: cartResponse.donor_email, // can be empty string if email not known
        products: [{
          id: data.campaignId || '',
          price: cartResponse.donated_amount,
          quantity: '1'
        }] // add new object for each product added to cart
      }
    };
    this.eventsService.gtmPush(dataLayerCartCreate);
    /**Claver tap push */
    const claverTapProperty = {
      'id': data.campaignId,
      'Step': 1,
      'Name': cartResponse.donor_name,
      'Email': cartResponse.donor_email,
      'NC Email ID': cartResponse.donor_email,
      'Type_AB': 'typeAB',
      'Parent Cause Id': this.vars.fundraiser.parent_cause_id,
      'Page Name': this.vars.campaignType || '',
      'iso_currency': cartResponse.currency,
      'amount': cartResponse.donated_amount - (cartResponse.tip_amount || 0),
      'TipAmount': cartResponse.tip_amount,
      'Cart ID': cartResponse.id,
      'Recurring': cartResponse.recurring ? true : false
    };
    if (this.vars.fundraiser) {
      claverTapProperty['Custom Tag'] = this.vars.fundraiser.custom_tag;
    }
    if (data.reward) {
      claverTapProperty['Amount'] = data.reward.amount_from;
      claverTapProperty['Reward'] = data.reward.id;
    }

    this.eventsService.claverTapPush('New Contribution', claverTapProperty);
    const campaignType = `${this.util.getCampaignTypeFromId(this.vars.fundraiser.parent_cause_id)}`;
    // Checkout/Cart create gtm event
    const gtmCheckout = {
      'event': 'addToCart',
      'sip': cartResponse.recurring,
      'value': cartResponse.donated_amount_inr,
      'currency': cartResponse.currency,
      'ecommerce': {
        'add': {
          'products': [{
            'name': `${this.vars.fundraiser.custom_tag}`, // Campaign Name
            'id': `${this.vars.fundraiser.id}`, // Campaign ID.
            'category': campaignType,  // Campaign Type
            'variant': `${this.vars.fundraiser.cause_id}`,
            'price': cartResponse.donated_amount_inr,
            'quantity': 1,
            'dimension5': '', // cd_Fundraiser Attributes,
            'dimension6': cartResponse.currency,
            'dimension7': `${this.vars.fundraiser.cause_id}`, // cd_Campaign Cause ID
            'dimension8': `${this.vars.fundraiser.custom_tag}`, // cd_Campaign Custom Tag
            'dimension9': `${this.vars.fundraiser.id}`, // cd_Campaign ID
            'dimension10': campaignType, // cd_Campaign Type
            'dimension15': cartResponse.donated_amount_inr, // cd_Donation Amount
            'dimension16': this.vars.selectTipPercentage || '', // cd_Tip Percentage
            'dimension17': cartResponse.tip_amount_inr, // cd_Tip Amount,
          }]
        }
      }
    };
    this.eventsService.gtmPush(gtmCheckout);
    this.eventsService.fbPixelPush('AddToCart', {});

    if (this.vars.fundraiser?.is_multi_patient_campaign && this.vars.pageName.match('stories|mini_story')) {
      const payload = {
        eventName: 'multi_patient_dropdown_shown',
        info_1: this.vars.donateMultiPatient ? 'enabled' : 'disabled',
        event_type_id: this.vars?.fundraiser?.id
      }
      this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
    }
  }
  /**Contribute initiated system events */
  contributeInitiatedEvents(position?) {
    const cart = this.cartResponse.getValue();
    const claverTapProperty = {
      'Position': 11,
      'Cart ID': cart ? cart.id : '',
      'Recurring': cart ? (cart.recurring ? true : false) : false
    };
    if (this.vars.selected_insurance) {
      claverTapProperty['Plan Type'] = this.vars.selected_insurance.plan_text;
      claverTapProperty['Plan Validity'] = this.util.toTitleCase(this.vars.selected_insurance.frequency);
    }
    if (this.vars.fundraiser) {
      claverTapProperty['Custom Tag'] = this.vars.fundraiser.custom_tag;
    }
    this.eventsService.claverTapPush('Contribution Initiated', claverTapProperty);

    const dataLayer = {
      'event': 'Contribution Initiated',
      'event_category': 'Contribution Initiated',
      'event_action': 'click',
      'event_label': this.vars.fundraiser.title,
      'Campaign_custom_tag': this.vars.fundraiser.custom_tag,
      'Campaign_cause_id': this.vars.fundraiser.cause_id,
      'Campaign_id': Number(this.vars.fundraiser.id),
      'Campaign_Type': this.util.getCampaignTypeFromId(this.vars.fundraiser.parent_cause_id),
      'position': position || 11,
      sip: this.vars.gtmPageData ? this.vars.gtmPageData.sip : false
    };
    this.eventsService.gtmPush(dataLayer);
    this.eventsService.fbPixelPush('InitiateCheckout', {});
    const systemEvent = {
      eventName: 'Contribution Initiated',
      event_type: 'campaign',
      page_name: this.vars.pageName || '',
      info_1: this.vars.event_info.info_1 || 'position',
      info_2: this.vars.event_info.info_2 || position || 11,
      info_3: this.vars.event_info.info_3 || this.vars.campaignType || '',
      info_4: this.vars?.event_info?.info_4 || this.cookieService.getCookie('varAB') || ''
    };
    if (this.vars?.fundraiser?.id) {
      systemEvent['event_type_id'] = this.vars?.fundraiser?.id;
    }

    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }

  sendDonationSlabEvent(contributeDet) {
    if (contributeDet) {
      const systemEvent = {
        eventName: 'Donation_Slabs',
        event_type: 'campaign',
        page_name: this.vars.pageName || '',
        info_1: JSON.stringify(contributeDet.slabs),
        info_4: this.cookieService.getCookie('varAB') || '',
      };
      if (this.vars?.fundraiser?.id) {
        systemEvent['event_type_id'] = this.vars?.fundraiser?.id;
      }
      this.eventsService.sendSystemEvent(systemEvent).subscribe(r => { });
    }
  }

  /**All the event push */
  succesfullOrderEvents(order: IOrder) {
    const gtmPurchased = {
      'event': 'purchase',
      'sip': order.subscription_id ? true : false,
      'transaction_id': order.order_id,
      'value': order.donated_amount_local,
      'currency': order.iso_currency,
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': order.order_id, // Transaction ID
            'revenue': order.donated_amount, // Total transaction
          },
          'products': [{
            'name': order.campaign.custom_tag, // Campaign Name
            'id': order.campaign.id, // Campaign ID.
            'category': this.util.getCampaignTypeFromId(order.campaign.parent_cause_id),  // Campaign Type
            'variant': order.campaign.cause_id,
            'price': order.donated_amount,
            'quantity': 1,
            'dimension5': '', // cd_Fundraiser Attributes
            'dimension7': order.campaign.cause_id, // cd_Campaign Cause ID
            'dimension8': order.donor_first_name, // cd_Campaign Custom Tag
            'dimension9': order.campaign.id, // cd_Campaign ID
            'dimension10': this.util.getCampaignTypeFromId(order.campaign.parent_cause_id), // cd_Campaign Type
            'dimension15': order.donated_amount, // cd_Donation Amount
            'dimension16': this.vars.selectTipPercentage || '', // cd_Tip Percentage
            'dimension17': order.tip_amount // cd_Tip Amount
          }],
          'amount_slab': this.getAmount_slab(order.donated_amount)
        }
      }
    };
    this.eventsService.gtmPush(gtmPurchased);
    this.eventsService.fbPixelPush('Purchase', {
      value: order.donated_amount,
      currency: 'INR',
      eventId: order.order_id,
      content_name: order.order_id
    });

    this.adgebra(order);
    try {
      fbp_purchase_data = {
        content_name: `${order.campaign.title}`,
        content_category: `${order.campaign.cause_id}`,
        content_ids: `${order.campaign.id}`,
        content_type: 'product',
        value: `${order.donated_amount}`,
        currency: 'INR'
      };
    } catch (e) { }
    this.vwoPush(order);
  }

  getAmount_slab(value) {
    switch (true) {
      case value > 1 && value <= 500:
        return 'Purchase_500';
      case value > 500 && value <= 1000:
        return 'Purchase_1000';
      case value > 1000 && value <= 1500:
        return 'Purchase_1500';
      case value > 1500 && value <= 2000:
        return 'Purchase_2000';
      case value > 2000 && value <= 5000:
        return 'Purchase_5000';
      case value > 5000:
        return 'Purchase_5000plus';
    }
  }
  /** Adgebra conversion */
  adgebra(order) {
    if (this.util.isBrowser) {
      const p1 = '987';
      const p2 = `${order.order_id}`;
      const p3 = `${order.campaign.id}`;
      const p4 = `${order.donated_amount}`;
      const p5 = '';
      const adgConvScrpt = document.createElement('script');
      document.body.appendChild(adgConvScrpt);
      adgConvScrpt.async = true;
      const adgConvParam = 'p1=' + p1 + '&p2=' + p2 + '&p3=' + p3 + '&p4=' + p4 + '&p5=' + p5;
      adgConvScrpt.id = 'adg_conversion_pixel';
      adgConvScrpt.src = 'https://adgebra.co.in/Tracker/Conversion.js?' + adgConvParam;
    }
  }
  vwoPush(order) {
    if (typeof window !== 'undefined') {
      (<any>window).VWO = (<any>window).VWO || [];
      (<any>window)._vis_opt_queue = (<any>window)._vis_opt_queue || [];
      (<any>window)._vis_opt_queue.push(() => {
        (<any>window)._vis_opt_revenue_conversion(`${order.donated_amount}`);
      });
      (<any>window).VWO.push(['track.revenueConversion', `${order.donated_amount}`]);
    }
  }

  /**After successfull payment event related to user */
  userEventsAfterPayment(order, userdata, queryParams) {
    const basicInfo = this.vars.basicInfo;
    const claverTap = {
      'Campaign Name': `${order.campaign.title}`,
      'Urlencode Campaign Name': encodeURI(order.campaign.title),
      'Truncated Campaign Name': order.campaign.title.length > 20 ? order.campaign.title.substr(0, 20).concat('...') : order.campaign.title,
      'Campaign Id': `${order.campaign.id}`,
      'Amount': `${order.donated_amount_local}`,
      'Reward Id': `${order.rewards_id}`,
      'Charged ID': `${order.order_id}`,
      'Cause ID': `${order.campaign.cause_id}`,
      'Device Type': this.util.isMobile() ? 'mobile' : 'Desktop',
      'Page Version': 'Angular',
      'Type_AB': '',
      'Donor Name': order?.donor?.full_name || userdata?.full_name,
      'Email ID': order?.donor?.email || userdata?.email,
      'Beneficiary Name': basicInfo?.beneficiary_name || '',
      'Parent Cause ID': order.campaign.parent_cause_id,
      'Description Of Campaign': basicInfo && basicInfo.about ? basicInfo.about.substr(0, 160).concat('...') : '',
      'Custom Tag': order.campaign.custom_tag,
      'ISO Currency': order.iso_currency,
      'Identity': userdata ? userdata.id : 0,
      'Monthly giving': order.recurring ? 'Yes' : 'No',
      'Tip Added': order?.tip_amount_local ? 'Yes' : 'No',
      'Tip Amount': order.tip_amount_local || '',
      'Payment mode': order?.payment_mode,
      'NGO ID': order?.campaign?.entity_details_id,
      'Event ID': order?.campaign?.event_entity_details_id,
      'Update Page URL': `${environment.APP.DOMAIN_URL}/new/campaign/campaign_update?fmd_id=${order.campaign.id}&email=${userdata.email}&is_donor=1&donated_amount=${order.donated_amount}&donated_currency=${order.iso_currency}&tyvideobtd=true`,
      'Multipatient Page': order?.is_multi_patient_campaign ? 'Yes' : 'No'
    };

    if (order?.is_multi_patient_campaign) {
      claverTap['New Beneficiary Name'] = order?.sub_campaign?.beneficiaryname?.info_1;
      claverTap['Child Campaign Id'] = order?.sub_campaign?.id;
      // claverTap['Campaign Name'] = order?.sub_campaign?.title;
      // claverTap['Urlencode Campaign Name'] = encodeURI(order?.sub_campaign?.title);
      // claverTap['Truncated Campaign Name'] = order?.sub_campaign?.title.length > 20 ? order?.sub_campaign?.title.substr(0, 20).concat('...') : order?.sub_campaign?.title;
      // claverTap['Campaign Id'] = order?.sub_campaign?.id;
      // claverTap['Custom Tag'] = order?.sub_campaign?.custom_tag;
      // claverTap['Update Page URL'] = `${environment.APP.DOMAIN_URL}/new/campaign/campaign_update?fmd_id=${order?.sub_campaign?.id}&email=${userdata.email}&is_donor=1&donated_amount=${order.donated_amount}&donated_currency=${order.iso_currency}&tyvideobtd=true`;
    }

    if (this.vars.selected_insurance) {
      claverTap['Plan Type'] = this.vars.selected_insurance.plan_text;
      claverTap['Plan Validity'] = this.util.toTitleCase(this.vars.selected_insurance.frequency);
    }

    if (order.transaction_return_status === '200') {
      this.eventsService.claverTapPush('Charged', this.util.removeEmptyFromObject(claverTap));

      if (!order.recurring) {
        this.eventsService.claverTapPush('Charged OTD', this.util.removeEmptyFromObject(claverTap));
      }
    }

    if (order.recurring) {
      const recurringOrder = {
        'Name': order.donor.full_name,
        'Amount': order.donated_amount,
        'BeneficiaryName': basicInfo?.beneficiary_name || '',
        'CampaignerName': order.campaign.campaigner.full_name,
        'CampaignName': order.campaign.title,
        'CampaignID': order.campaign.id,
        'Subscription date': Math.round(new Date(order.recurring.creation_time).getTime() / 1000),
        'SubscriptionMonths': order.recurring.tenure,
        'Payment Mode Type': order.payment_mode,
        'Subscription ID': order.subscription_id,
        'LocalAmount': order.donated_amount_local,
        'LocalCurrency': order.iso_currency,
        // 'Coupon Added': order.offer || false
        'Coupon Added': order.coupon || '',
        'Charge Cause': order?.recurring?.campaign_cause,
        'User Type': queryParams?.utm_source || '',
        'Next Deduction Date': (new Date(order?.recurring?.next_payment_date))?.toLocaleDateString('en-GB')?.split('/')?.join('-'),
        'Next Deduction Amount': order?.recurring?.amount,
        'Donation date': (new Date(order?.creation_date))?.toLocaleDateString('en-GB')?.split('/')?.join('-'),
        'Transaction ID': order?.order_id
      };

      let cause_list = '';
      let amount_list = '';
      if (queryParams?.sip_cause && typeof queryParams?.sip_cause === 'object' && queryParams?.sip_cause?.length > 1) {
        queryParams?.sip_cause.forEach((element, i) => {
          cause_list = cause_list + `${element?.sip_cause || element}${i < queryParams?.sip_cause?.length - 1 ? ',' : ''}`
          amount_list = amount_list + `${userdata?.listsubscriptions?.[element?.sip_cause || element]?.amount}${i < queryParams?.sip_cause?.length - 1 ? ',' : ''}`
        });
        recurringOrder['multi_cause'] = true;
        recurringOrder['cause_list'] = cause_list;
        recurringOrder['amount_list'] = amount_list;
      }

      if (this.vars.selected_insurance) {
        recurringOrder['Plan Type'] = this.vars.selected_insurance.plan_text;
      }

      this.eventsService.claverTapPush('Monthly Giving Impact', this.util.removeEmptyFromObject(recurringOrder));
    }

    const profilePushData = {
      'last_charged_amount': order.donated_amount_local,
      'last_charged_tip_amount': order.tip_amount_local,
      'last_charged_beneficiaryname': basicInfo.beneficiary_name,
      'last_charged_campaignid': order.campaign.id,
      'last_charged_campaignname': order.campaign.title,
      'last_charged_orderid': order.order_id,
      'last_charged_customtag': order.campaign.custom_tag,
      'last_charged_descriptionofcampaign': basicInfo && basicInfo.about ? basicInfo.about.substr(0, 160).concat('...') : '',
      'last_charged_identity': userdata ? userdata.id : 0,
      'last_charged_email_id': userdata?.email || '',
      'last_charged_isocurrency': order.iso_currency,
      'last_charged_parentcauseid': order.campaign.parent_cause_id,
      'last_charged_mobilenumber': order.donor.phone_1 || '',
      'SIP Active Donor': userdata?.listsubscriptions?.medical ? 'Yes' : 'No',
    };

    if (!userdata.hasOwnProperty('listsubscriptions')) {
      profilePushData['SIP Active Donor'] = null;
    }

    if ((order.payment_gateway === 'stripe' || order.payment_gateway === 'stripe_india') && !userdata?.listsubscriptions?.medical) {
      profilePushData['eligible_for_one_click_activation'] = 'Yes';
    }

    // User attributes using charged events
    this.eventsService.claverProfilePush({ 'Site': this.util.removeEmptyFromObject(profilePushData) });

    // Criteo Sales dataLayer
    const criteoDataLayer = {
      event: 'crto_transactionpage',
      currency: `${order.iso_currency}`,
      crto: {
        email: `${userdata ? userdata.email : ''}`,
        transactionid: `${order.id}`,
        products: [{
          id: `${order.campaign.id}`,
          price: `${order.donated_amount_local}`,
          quantity: '1'
        }]
      }
    };
    this.eventsService.gtmPush(criteoDataLayer);
  }

  getSelectedProductAsInfo() {
    let info1 = '';
    this.vars.selectedKCart.forEach((val, i) => {
      info1 += `${val?.name},${val?.unit_count},${+val?.per_unit_amount * +val?.unit_count}` + (i+1 < this.vars.selectedKCart?.length ? ',' : '');
    });
    return info1;
  }

}
